module.exports = __webpack_public_path__ + "static/media/carousel-placeholder-04.00651347.jpg";